import { LoadingIndicator } from '@abb/abb-common-ux-react';
import React from 'react';
import Loadable from 'react-loadable';

const LoadableComponent = (component: any): Loadable.LoadableComponent =>
  Loadable({
    loader: component,
    loading: () => <LoadingIndicator
      color="red"
      determinate={false}
      sizeClass="medium"
      type="bar"
      value={0}
    />
  });

export default LoadableComponent;
